import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { cloneGroups } from '../../services/GroupsService';
import { Group, CloneGroupsRequest } from '../../types/Groups';

type Result = UseMutationResult<Group, Error, CloneGroupsRequest>;

function useCloneGroups(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(cloneGroups, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['groups'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default useCloneGroups;
